import * as _ from 'lodash';

import DecimalForGlobals from './DecimalForGlobals';
import ComprobanteGlobalImpuestosCalculator from './ComprobanteGlobalImpuestosCalculator';
import ComprobanteConceptoImpuestosCalculator from './ComprobanteConceptoImpuestosCalculator';

class ComprobanteImpuestosCalculator {
  data = {};

  constructor(data) {
    this.data = _.cloneDeep(data);
  }

  apply() {
    this.withImpuestosConceptos().withImpuestosGlobales().withTotales();

    return this;
  }

  get() {
    return this.data;
  }

  withImpuestosConceptos() {
    let tipo = this.data.TipoDeComprobante;

    if (tipo === 'Traslado' || tipo === 'T') {
      return this;
    }

    let items = _.get(this.data, 'Conceptos.Concepto') || [];

    for (const item of items) {
      const traslados = _.get(item, 'Impuestos.Traslados.Traslado') || [];
      const retenciones = _.get(item, 'Impuestos.Retenciones.Retencion') || [];

      const impuestos = new ComprobanteConceptoImpuestosCalculator(item, traslados, retenciones).apply();

      if (!!impuestos) {
        item.Impuestos = impuestos;
      }
    }

    this.data.Conceptos.Concepto = items;

    return this;
  }

  withImpuestosGlobales() {
    let tipo = this.data.TipoDeComprobante;

    if (tipo === 'Traslado' || tipo === 'T') {
      return this;
    }

    const impuestos = new ComprobanteGlobalImpuestosCalculator(this.data).apply();

    if (!!impuestos) {
      this.data.Impuestos = impuestos;
    }

    return this;
  }

  withTotales() {
    let items = _.get(this.data, 'Conceptos.Concepto') || [];
    let subtotal = 0;
    let discount = 0;
    let totalTrasladado = 0;
    let totalRetenido = 0;
    let total = 0;

    for (const item of items) {
      subtotal = parseFloat(subtotal) + parseFloat(item.Importe);
      discount = parseFloat(discount) + parseFloat(item.Descuento || 0);

      const traslados = _.get(item, 'Impuestos.Traslados.Traslado') || [];

      for (const traslado of traslados) {
        totalTrasladado = parseFloat(totalTrasladado) + parseFloat(traslado.Importe || 0);
      }

      const retenciones = _.get(item, 'Impuestos.Retenciones.Retencion') || [];

      for (const retencion of retenciones) {
        totalRetenido = parseFloat(totalRetenido) + parseFloat(retencion.Importe || 0);
      }
    }

    subtotal = DecimalForGlobals.make(subtotal).toFixed();
    discount = DecimalForGlobals.make(discount).toFixed();
    totalRetenido = DecimalForGlobals.make(totalRetenido).toFixed();
    totalTrasladado = DecimalForGlobals.make(totalTrasladado).toFixed();

    total = parseFloat(subtotal) - parseFloat(discount) + parseFloat(totalTrasladado) - parseFloat(totalRetenido);

    this.data.SubTotal = subtotal;
    this.data.Descuento = discount;
    this.data.Total = DecimalForGlobals.make(total).toFixed();

    return this;
  }
}

export default ComprobanteImpuestosCalculator;
